// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"cd38e4cc","141":"ecba91b5","177":"d418c607","329":"4b2003f9","453":"eafda266","713":"0bb1f6eb","807":"cd5a8d76"}[chunkId] + ".chunk.js";
};